import { TextArea } from "@astryxdesign/core/TextArea";

interface Props {
  label: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  rows: number;
  /** Message to show as an inline error, or null when the value is fine. */
  error: string | null;
}

/**
 * TextArea that takes `error: string | null` instead of an optional `status`.
 * Same reason as {@link TextInputMaybeError} — see that file.
 */
export function TextAreaMaybeError({
  label,
  placeholder,
  value,
  onChange,
  rows,
  error,
}: Props) {
  if (error !== null) {
    return (
      <TextArea
        label={label}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        rows={rows}
        hasSpellCheck={false}
        status={{ type: "error", message: error }}
      />
    );
  }
  return (
    <TextArea
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      rows={rows}
      hasSpellCheck={false}
    />
  );
}
